import type { IProjectRepository } from '../repositories/IProjectRepository.js';
import type { ProjectEntity } from '../entities/ProjectEntity.js';

interface Deps { projectRepository: IProjectRepository; }

export function createSearchProjectsUseCase({ projectRepository }: Deps) {
  return async function searchProjects(orgId: string, query: string, limit?: number): Promise<ProjectEntity[]> {
    return projectRepository.searchProjects(orgId, query, limit);
  };
}
